export default {
    name: "appHeader",
    data() {
        return {
            menu: false
        }
    }
}
